import React from 'react';
import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Shown to users whose account is not yet approved.
 * approvalStatus: 'pending' | 'rejected'
 * role: 'client' shows account-under-review copy; otherwise contractor/verifier copy.
 */
export default function PendingVerificationBanner({ approvalStatus, role }) {
  const navigate = useNavigate();
  if (approvalStatus === 'approved') return null;

  const rejected = approvalStatus === 'rejected';
  const isClient = role === 'client';

  if (rejected) {
    return (
      <Box sx={{ mb: 3 }}>
        <Alert severity="error" variant="outlined">
          <AlertTitle>Account not approved</AlertTitle>
          <Typography variant="body2">
            Your account was not approved. Please contact{' '}
            <a href="mailto:info@eqaya.com">info@eqaya.com</a> for details.
          </Typography>
        </Alert>
      </Box>
    );
  }

  if (isClient) {
    return (
      <Box sx={{ mb: 3 }}>
        <Alert severity="info" variant="outlined">
          <AlertTitle>Account under review</AlertTitle>
          <Typography variant="body2">
            Our team is verifying recently created accounts and will contact you shortly. You can
            browse the platform meanwhile — booking property checks, requesting quotes, and payments
            will be available once your account is approved.
          </Typography>
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Alert severity="info" variant="outlined">
        <AlertTitle>Verification pending</AlertTitle>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Our team is reviewing your application. You can browse and complete your profile now —
          adding your portfolio, certificates, and references speeds up your verification.
          Marketplace actions unlock once you're approved.
        </Typography>
        <Button size="small" variant="contained" onClick={() => navigate('/profile')}>
          Complete your profile
        </Button>
      </Alert>
    </Box>
  );
}
